import { gql } from "@apollo/client";
import { GlobalSettingsNoNestingFragment } from "@towersystems/roam-common/lib/generated-graphql-fragment";

export const GLOBAL_SETTINGS_KEY = "__GLOBAL_SETTINGS_KEY__";

const RemovalAiDetailsFragment = gql`
  fragment RemovalAiDetails on GlobalSettings {
    removalAiDetails {
      apiKey
    }
  }
`;

const RemovalBgDetailsFragment = gql`
  fragment RemovalBgDetails on GlobalSettings {
    removalBgDetails {
      apiKey
    }
  }
`;

export const GlobalSettingsQuery = gql`
  ${RemovalBgDetailsFragment}
  ${RemovalAiDetailsFragment}
  ${GlobalSettingsNoNestingFragment}
  query globalSettings {
    globalSettings {
      ...GlobalSettingsNoNesting
      ...RemovalAiDetails
      ...RemovalBgDetails
    }
  }
`;

export const MUTATION_UPDATE_GLOBAL_SETTINGS = gql`
  ${RemovalBgDetailsFragment}
  ${RemovalAiDetailsFragment}
  ${GlobalSettingsNoNestingFragment}
  mutation updateGlobalSettings($input: UpdateGlobalSettingsInput!) {
    updateGlobalSettings(input: $input) {
      ...GlobalSettingsNoNesting
      ...RemovalAiDetails
      ...RemovalBgDetails
    }
  }
`;
